import PropTypes from 'prop-types'
import React from 'react'
import SydButton from '../../../../../commonDesign/Button'
import { useCheckPolicy } from '../../../../../../hooks'

function ViewContentHeaderControls ({
  onToggleDesigner,
  designerLoading,
  views,
  viewMode,
  onViewModeChange
}) {
  const canAccessDesigner = useCheckPolicy('internalOnly')

  return (
    <div className='flex flex-col gap-sm items-end' style={{ paddingRight: 2 }}>
      <div className='flex items-center gap-sm'>
        {canAccessDesigner ? (
          <SydButton
            variant='ai'
            icon='sparkles'
            size='md'
            onClick={onToggleDesigner}
            processing={designerLoading}
          >
            Designer
          </SydButton>
        ) : null}
      </div>

      <div className='flex items-center gap-sm'>
        {views.map(({ id, title, icon, size, disabled, disabledReason }) => (
          <span
            key={id}
            // Wrapping span carries the HTML tooltip so disabled buttons still
            // show a hover hint (some browsers block events on disabled <button>).
            title={disabled ? disabledReason : title}
            style={{ display: 'inline-flex' }}
          >
            <SydButton
              icon={icon}
              size={size}
              disabled={disabled}
              variant={viewMode === id ? 'primary' : 'secondary'}
              onClick={() => onViewModeChange(id)}
            >
              {title}
            </SydButton>
          </span>
        ))}
      </div>
    </div>
  )
}

ViewContentHeaderControls.propTypes = {
  onToggleDesigner: PropTypes.func,
  designerLoading: PropTypes.bool,
  views: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.string,
    size: PropTypes.string,
    disabled: PropTypes.bool,
    disabledReason: PropTypes.string
  })),
  viewMode: PropTypes.string,
  onViewModeChange: PropTypes.func
}

ViewContentHeaderControls.defaultProps = {
  onToggleDesigner: undefined,
  designerLoading: false,
  views: [],
  viewMode: '',
  onViewModeChange: undefined
}

export default ViewContentHeaderControls
